module.exports = __webpack_public_path__ + "img/team-bg-image.89cd49f7.svg";